import React, {Component} from "react";
import {connect} from "react-redux";
import {ActionCreator} from "../../../../../../actions/actions";
import {HallsActionCreators} from "../../../../actions/actionCreators";
import MarketFilter from "./Filters/MarketFilter.component";
import "./HallsPageFilters.component.scss";
import {HallFilterTypes, HallListViews} from "../../../../types/filters";
import {hallsStoreSelectors} from "../../../../store/store";
import {HallsListFilters} from "../../../../reducers/hallsListFilters.reducer";
import {Components} from "@webtech/webtech-ui-react/build/webtech-ui";
import {STARTING_PAGE} from "../../../../reducers/hallsList.reducer";

interface HallsPageFiltersProps {
    getAllHalls: any;
    clearHallListFilters: ActionCreator;
    changeHallListFilter: ActionCreator;
    loading: boolean;
    filters: HallsListFilters;
    onPageChange: any;
}

class HallsPageFilters extends Component<HallsPageFiltersProps, {}> {
    private marketFilter;

    constructor(props) {
        super(props);
        this.marketFilter = React.createRef();
    }

    onClearFilters = () => {
        this.props.clearHallListFilters();
        //this.props.onPageChange();
        //this.marketFilter.clearFilter();
        this.props.onPageChange(STARTING_PAGE + 1);
    };

    onChangeSearch = e => {
        this.props.changeHallListFilter({
            type: HallFilterTypes.SEARCH,
            filterValues: [e.target.value]
        });
        this.props.onPageChange(STARTING_PAGE + 1, false);
    };

    onFilterMarket = markets => {
        this.props.changeHallListFilter({
            type: HallFilterTypes.MARKET,
            filterValues: markets
        });
        this.props.onPageChange(STARTING_PAGE + 1, false);
    };

   /*onServerStatus = value => {
        this.props.changeHallListFilter({
            type: HallFilterTypes.SERVER_TYPE,
            filterValues: [value]
        });
    };*/

    onHallStatus = value => {
        this.props.changeHallListFilter({
            type: HallFilterTypes.HALL_STATUS,
            filterValues: [value]
        });
        this.props.onPageChange(STARTING_PAGE + 1, false);
    };

    onViewMode = value => {
        this.props.changeHallListFilter({
            type: HallFilterTypes.VIEW_MODE,
            filterValues: [value]
        });
    };

    render() {
        /*const serverStatus = [
            {
                value: "",
                label: "All"
            },
            {
                value: 1,
                label: "On"
            },
            {
                value: 0,
                label: "Off"
            }
        ];*/

        const hallStatus = [
            {
                value: "",
                label: "All"
            },
            {
                value: 1,
                label: "Active"
            },
            {
                value: 0,
                label: "Inactive"
            }
        ];

        return (
            <div id="HallsPageFiltersBox">
                <div className="row">
                    <div className="adjustable-filters">
                        <div className="hall-filter">
                            <label className="label">Search</label>
                            <input
                                className="input"
                                onChange={this.onChangeSearch}
                                value={this.props.filters.search}
                                placeholder="Hall name"
                            />
                        </div>

                        <div className="hall-filter">
                            <label className="label">Subsidiaries</label>
                            <MarketFilter
                                ref={ref => (this.marketFilter = ref)}
                                filter={this.props.filters.market}
                                onFilterMarket={this.onFilterMarket}
                            />
                        </div>

                        <div className="hall-filter">
                            <label className="label">Hall Status</label>
                            <Components.CheckboxGroup
                                key={this.props.filters.hallStatus}
                                items={hallStatus}
                                selected={this.props.filters.hallStatus}
                                onChange={this.onHallStatus}
                            />
                        </div>
                    </div>
                    <div className="hall-filter server-status">
                        <label> </label>
                        {/*<label className="label">Server Status</label>*/}
                        <div className="filter-actions">
                            {/*<Components.CheckboxGroup
                                items={serverStatus}
                                selected={this.props.filters.serverStatus}
                                onChange={this.onServerStatus}
                            />*/}
                            <div className="view-type">
                                <button
                                    className={
                                        this.props.filters.viewMode ==
                                        HallListViews.GRID
                                            ? `active`
                                            : ""
                                    }
                                    onClick={() =>
                                        this.onViewMode(HallListViews.GRID)
                                    }
                                >
                                    <i className="icon-th-solid"/>
                                </button>
                                <button
                                    className={
                                        this.props.filters.viewMode ==
                                        HallListViews.LIST
                                            ? `active`
                                            : ""
                                    }
                                    onClick={() =>
                                        this.onViewMode(HallListViews.LIST)
                                    }
                                >
                                    <i className="icon-align-justify-light"/>
                                </button>
                            </div>
                            <div>
                                <button
                                    className="clear-filters-btn"
                                    onClick={this.onClearFilters}
                                >
                                    Clear All Filters
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    filters: hallsStoreSelectors.filters(state)
});

const mapDispatchToProps = {
    clearHallListFilters: HallsActionCreators.clearHallListFilters,
    changeHallListFilter: HallsActionCreators.changeHallListFilter
};

export default connect(mapStateToProps, mapDispatchToProps)(HallsPageFilters);
